module.exports = __webpack_public_path__ + "media/goforajourney/img/mexico-city-card-4c2b3f517262669a8c42faa6e52e6f9d.jpg";